/**
 * article-nav.js — zero-dependency header behaviour for article pages.
 *
 * Replaces the subset of wpbingo.min.js used on blog/article pages:
 *   • Sticky header (scroll > 200 px → .bwp-header.sticky)
 *   • Mobile menu toggle  (.js-menu-mobile  → body.menu-mobile--open)
 *   • Mobile sub-menu drill-down (.js-mm-nav-item)
 *   • Mobile search toggle (.js-header-search-toggle → body.modal-search--open)
 *   • Desktop search open/close (.search-toggle / [data-close-search-toggle])
 *
 * Cart is handled separately: footer-javascript.liquid loads the full
 * wpbingo bundle on-demand when the cart icon is clicked.
 *
 * ~2 KB unminified, zero dependencies, loads with defer.
 */
(function () {
  'use strict';

  /* Tells wpbingo.HeaderSection (site.js) not to bind its own copies of the
     same handlers below. On article/blog pages wpbingo.min.js only loads
     on demand (see footer-javascript.liquid — a search tap or a cart-icon
     tap pulls it in), and once it does, wpbingo.Sections auto-instantiates
     HeaderSection on the header, which binds its own click listeners for
     .js-menu-mobile and .js-header-search-toggle. Those duplicate the
     delegated handlers just below: a single real tap then fires BOTH,
     toggling the same body class twice, which cancels itself out and makes
     the hamburger/search look dead as soon as the bundle finishes loading —
     exactly the "opens once, stops working after that" reports. */
  window.AJ_HEADER_NAV_OWNED = true;

  /* ── sticky header ───────────────────────────────────────────────── */
  var header = document.querySelector('.bwp-header');
  if (header && header.getAttribute('data-sticky_header')) {
    var wasSticky = false;
    window.addEventListener(
      'scroll',
      function () {
        var sticky = window.scrollY > 200;
        if (sticky !== wasSticky) {
          wasSticky = sticky;
          header.classList.toggle('sticky', sticky);
        }
      },
      { passive: true }
    );
  }

  /* ── single delegated click handler ─────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    /* mobile menu open/close */
    if (t.closest('.js-menu-mobile')) {
      e.preventDefault();
      document.body.classList.toggle('menu-mobile--open');
      return;
    }

    /* mobile sub-menu drill-down */
    var mmItem = t.closest('.js-mm-nav-item');
    if (mmItem) {
      e.preventDefault();
      if (mmItem.classList.contains('mm-nav__prev')) {
        /* go back up one level */
        var hidden = mmItem.closest('.active--hidden');
        if (hidden) hidden.classList.remove('active--hidden');
      } else {
        /* drill into child level */
        var links = mmItem.closest('.mm-nav__links');
        if (links) links.classList.add('active--hidden');
      }
      var navItem = mmItem.closest('.menu-mobile__nav-item');
      if (navItem) navItem.classList.toggle('active');
      return;
    }

    /* mobile search toggle */
    if (t.closest('.js-header-search-toggle')) {
      e.preventDefault();
      document.body.classList.toggle('modal-search--open');
      return;
    }

    /* desktop search open */
    if (t.closest('.search-toggle')) {
      e.preventDefault();
      ajSearchToggle(true);
      return;
    }

    /* desktop search close */
    if (t.closest('[data-close-search-toggle]')) {
      e.preventDefault();
      ajSearchToggle(false);
    }
  });

  function ajSearchToggle(forceOpen) {
    /* header_5 ships 3 copies of .content-search-toggle (one per header
       breakpoint variant), only one of which is actually on screen at any
       given width. document.querySelector only ever grabs the FIRST one in
       the DOM, so a tap on the visible search icon could toggle .active on a
       box that CSS was already hiding elsewhere -- nothing visibly opened,
       even though the class toggle "worked". Toggle every copy instead; the
       ones display:none leaves hidden cost nothing. */
    var boxes = document.querySelectorAll('.content-search-toggle');
    var bars = document.querySelectorAll('.bwp-header-topbar');
    var firstBox = boxes[0];
    var open = typeof forceOpen === 'boolean' ? forceOpen : !(firstBox && firstBox.classList.contains('active'));
    for (var i = 0; i < boxes.length; i++) boxes[i].classList.toggle('active', open);
    for (var j = 0; j < bars.length; j++) bars[j].classList.toggle('active-index', open);
    document.body.classList.toggle('active_search', open);

    /* auto-focus the search input in whichever box is actually visible */
    if (open) {
      for (var k = 0; k < boxes.length; k++) {
        if (boxes[k].offsetParent === null) continue;
        var inp = boxes[k].querySelector('input[type="search"], input[name="q"]');
        if (inp) {
          /* small delay lets the CSS transition start first */
          setTimeout(function (input) { return function () { input.focus(); }; }(inp), 80);
        }
        break;
      }
    }
  }
})();
